import { render } from "./upload-picture.vue?vue&type=template&id=a90e0804&ts=true"
import script from "./upload-picture.vue?vue&type=script&lang=ts"
export * from "./upload-picture.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./upload-picture.vue?vue&type=style&index=0&id=a90e0804&lang=less&module=true"
cssModules["$style"] = style0
import "./upload-picture.vue?vue&type=style&index=1&id=a90e0804&lang=less"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__